import DebouncedResize from '../helpers/DebouncedResize'

export default class FactoidsBlock {
    constructor(root) {
        this.root = root;
        this.current_index = 0;
        this.main_content_container = this.root.querySelector('.js-content-container');
        this.content_containers = this.main_content_container.children;
        this.image_containers = this.root.querySelector('.js-image-container').children;

        this.prev_button = this.root.querySelector('.js-button-prev');
        this.next_button = this.root.querySelector('.js-button-next');

        this.prev_button.classList.add('--disabled');

        this.prev_button.addEventListener('click', (event) => {
            event.preventDefault();
            this.current_index -= 1;

            this.next_button.classList.remove('--disabled');

            if(this.current_index == 0) {
                this.prev_button.classList.add('--disabled');
            }

            this.update('down');
        });

        this.next_button.addEventListener('click', (event) => {
            event.preventDefault();
            this.current_index += 1;

            this.prev_button.classList.remove('--disabled');

            if(this.current_index == this.content_containers.length - 1) {
                this.next_button.classList.add('--disabled');
            }

            this.update('up');
        });

        this.showFirstSlide();
        this.startAutoUpdate();

        this.root.addEventListener('mouseover', (event) => {
            if(this.auto_update) {
                this.stopAutoUpdate();
            }
        });

        this.root.addEventListener('mouseout', (event) => {
            if(!this.auto_update) {
                this.startAutoUpdate();
            }
        });

        new DebouncedResize(() => {
            let current_height = 0;

            Array.from(this.content_containers).forEach((content_container) => {
                let container_height = content_container.getBoundingClientRect().height;

                if(container_height > current_height) {
                    current_height = container_height;
                }
            });

            this.main_content_container.style.height = current_height + 'px';
        }, null, true);
    }

    stopAutoUpdate() {
        clearInterval(this.auto_update);
        this.auto_update = null;
    }

    startAutoUpdate() {
        this.auto_update = setInterval(() => {
            if(!this.next_button.classList.contains('--disabled')) {
                this.next_button.click();
            } else if(!this.prev_button.classList.contains('--disabled')) {
                this.showFirstSlide();
            }
        }, 8000);
    }

    showFirstSlide() {
        this.current_index = 0;
        this.prev_button.classList.add('--disabled');
        this.next_button.classList.remove('--disabled');

        Array.from(this.content_containers).forEach((content_container, index) => {
            if(index == 0) {
                content_container.classList.add('--fade-in-up');
                content_container.classList.add('--active');
                this.image_containers[index].classList.add('--fade-in-up');
                this.image_containers[index].classList.add('--active');
            } else {
                content_container.classList.remove('--fade-in-up');
                content_container.classList.remove('--fade-out-up');
                content_container.classList.remove('--fade-in-down');
                content_container.classList.remove('--fade-out-down');
                content_container.classList.remove('--active');
                this.image_containers[index].classList.remove('--fade-in-up');
                this.image_containers[index].classList.remove('--fade-out-up');
                this.image_containers[index].classList.remove('--fade-in-down');
                this.image_containers[index].classList.remove('--fade-out-down');
                this.image_containers[index].classList.remove('--active');
            }

            content_container.classList.add('--moving-up');
            this.image_containers[index].classList.add('--moving-up');
        });
    }

    update(direction) {
        let fade_in_class = '--fade-in-' + direction;
        let fade_out_class = '--fade-out-' + direction;
        let moving_class = '--moving-' + direction;

        Array.from(this.content_containers).forEach((content_container, index) => {
            content_container.classList.remove('--moving-up');
            content_container.classList.remove('--moving-down');

            this.image_containers[index].classList.remove('--moving-up');
            this.image_containers[index].classList.remove('--moving-down');

            content_container.classList.add(moving_class);
            this.image_containers[index].classList.add(moving_class);
        });

        setTimeout(() => {
            Array.from(this.content_containers).forEach((content_container, index) => {
                content_container.classList.remove('--active');
                content_container.classList.remove('--fade-in-up');
                content_container.classList.remove('--fade-in-down');
                content_container.classList.remove('--fade-out-up');
                content_container.classList.remove('--fade-out-down');

                this.image_containers[index].classList.remove('--active');
                this.image_containers[index].classList.remove('--fade-in-up');
                this.image_containers[index].classList.remove('--fade-in-down');
                this.image_containers[index].classList.remove('--fade-out-up');
                this.image_containers[index].classList.remove('--fade-out-down');

                if(index == this.current_index) {
                    content_container.classList.remove(fade_out_class);
                    content_container.classList.add(fade_in_class);
                    content_container.classList.add('--active');

                    this.image_containers[index].classList.remove(fade_out_class);
                    this.image_containers[index].classList.add(fade_in_class);
                    this.image_containers[index].classList.add('--active');
                } else {
                    content_container.classList.add(fade_out_class);

                    this.image_containers[index].classList.add(fade_out_class);

                    setTimeout(() => {
                        content_container.classList.remove(fade_out_class);
                        this.image_containers[index].classList.remove(fade_out_class);
                    }, 250);
                }
            });
        }, 100);
    }
}
